export enum LegsFilter {
  All = 'ALL',
  Booked = 'BOOKED',
  Empty = 'EMPTY'
}
